import {
  Music24Capabilities,
  Music24PaidPlanTier,
  music24ExtraArtistMonthlyCents,
} from 'fym-shared/src/music24/music24Plans';
import { planHasExtraArtistAddOn } from 'fym-shared/src/music24/monthlyAddOns';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import type { PlanStore } from './usePlanStore';

/** One more paid artist on the current plan (plans rename 2026-10-23, decision D1). */
export interface ExtraArtistOffer {
  tier: Exclude<Music24PaidPlanTier, 'plug'>;
  /** The paid extra artists after the purchase. */
  extraArtists: number;
  /** The monthly price of one extra artist in US cents (integer). EUR uses the same number. */
  monthlyCents: number;
}

/**
 * The extra-artist offer for an `artists` prompt. A workspace on Plus, Pro, Max or Ultra below the
 * cap of its plan buys one more artist at the plan price minus 20 %. Free, the trial, Plug and a
 * full Plus, Pro or Max get null: the prompt then offers the next plan. A plan that was bought in an
 * app store gets null too: the store sells no extra artist, and the web checkout refuses a store
 * plan. Pure.
 */
export function extraArtistOfferFor(
  feature: SMLUpgradeFeature,
  current: Music24Capabilities,
  planStore: PlanStore | null
): ExtraArtistOffer | null {
  const { plan } = current;
  if (feature !== SMLUpgradeFeature.artists || plan === 'free' || plan === 'trial' || plan === 'plug') {
    return null;
  }
  if (planStore !== null) {
    return null;
  }
  if (!planHasExtraArtistAddOn(plan)) {
    return null;
  }
  const paidExtraArtists = Math.max(0, (current.artistsLimit ?? current.includedArtists) - current.includedArtists);
  if (current.extraArtistLimit !== null && paidExtraArtists >= current.extraArtistLimit) {
    return null;
  }
  return {
    tier: plan,
    extraArtists: paidExtraArtists + 1,
    monthlyCents: music24ExtraArtistMonthlyCents(plan),
  };
}
